import React, { useState } from 'react'
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Paper
} from '@mui/material'
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { useParams, useNavigate } from 'react-router-dom';
import { postData } from '../../Webservice/Webservice';
import { toast } from 'react-toastify';

function ForgotPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const isMismatch = confirmPassword && password !== confirmPassword;

  const handleSubmit = async () => {
    if (!password || !confirmPassword || isMismatch) return;

    setLoading(true);
    try {
      const payload = {
        newPassword: password,
      };
      const response = await postData(`customer/reset-password/${token}`, payload);
      if (response && !response.error) {
        toast.success("Password reset successfully. Please sign in with your new password.");
        navigate("/signin");
      }
    } catch (error) {
      console.error("Reset password error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('/img/mailbanner.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: "100%",
          maxWidth: 380,
          p: 4,
          borderRadius: 3,
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(255,255,255,0.9)",
          textAlign: "center",
        }}
      >
        <img
          src="/img/tvfmlogo2.png"
          alt="logo"
          style={{ width: 180, marginBottom: 20 }}
        />

        <Typography variant="h6" fontWeight="600" mb={1}>
          Reset Your Password
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          Enter and confirm your new password to continue
        </Typography>

        {/* New Password */}
        <TextField
          label="New Password"
          type={showPassword ? "text" : "password"}
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <IoIosEye /> : <IoIosEyeOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        {/* Confirm Password */}
        <TextField
          label="Confirm Password"
          type={showConfirmPassword ? "text" : "password"}
          variant="outlined"
          fullWidth
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          error={isMismatch}
          helperText={isMismatch ? "Passwords do not match" : ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                  {showConfirmPassword ? <IoIosEye /> : <IoIosEyeOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        <Button
          variant="contained"
          fullWidth
          sx={{
            mt: 3,
            py: 1.2,
            borderRadius: 2,
            backgroundColor: "#000",
            "&:hover": {
              backgroundColor: "#222",
            }
          }}
          disabled={!password || !confirmPassword || isMismatch || loading}
          onClick={handleSubmit}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </Button>
      </Paper>
    </Box>
  )
}

export default ForgotPasswordPage;

